export const buildConversionOptions = (conversion) => {
  if (!conversion) {
    return { metrics: [], options: {} };
  }

  if (Array.isArray(conversion.metrics) && conversion.options && typeof conversion.options === 'object') {
    return {
      metrics: conversion.metrics.map((metric) => String(metric)),
      options: conversion.options,
      conversionName: conversion.conversionName ?? conversion.Name,
    };
  }

  if (!conversion.ConversionValues) {
    return { metrics: [], options: {} };
  }

  const metricsSource = Array.isArray(conversion.AvailableMetrics)
    ? conversion.AvailableMetrics
    : String(conversion.AvailableMetrics || '')
        .split(',')
        .map((metric) => metric.trim())
        .filter(Boolean);
  const metrics = metricsSource.map((metric) => String(metric));
  const options = {};

  metrics.forEach((metric) => {
    options[metric] = conversion.ConversionValues
      .filter((item) => item.Metric === metric)
      .map((item) => ({
        value: String(item.Key),
        label: String(item.Value),
      }));
  });

  return {
    metrics,
    options,
    conversionName: conversion.Name,
  };
};

export const getConversionMetrics = (fieldConfig) => {
  if (String(fieldConfig.type || '').toLowerCase() !== 'conversion' || !fieldConfig.conversion) {
    return [];
  }

  return fieldConfig.conversion.metrics;
};

export const getConversionOptionsForMetric = (fieldConfig, metric) => {
  if (String(fieldConfig.type || '').toLowerCase() !== 'conversion' || !fieldConfig.conversion) {
    return [];
  }

  return fieldConfig.conversion.options[metric] || [];
};
